export default __webpack_public_path__ + "static/media/13.b8d59edf.jpg";